/**
 * Shared event-CTA visual language (W2.7, Dexter 2026-07-23). ONE source for the
 * filled-teal "attend" primary so the event surfaces read identical — no
 * copy-pasted class strings drifting apart (the CLAUDE.md cache-key drift rule,
 * applied to styling). Consumed by BOTH:
 *   - the event-page hero action row (`EventPageActions`, the "Join Event" CTA), and
 *   - the space-rail card's row-3 CTA (`LiveCompactCard`, "Join event" / "I am here").
 *
 * This module lives in the live-layer primitives directory because the barrel
 * already scopes those primitives to "event cards, Home rail, space home, event
 * page" — the event page IS a live surface — so both consumers import DOWN into a
 * shared primitive rather than one feature reaching into another.
 *
 * Only the scale-agnostic COLOR/GLOW treatment is shared; each consumer layers its
 * own scale (the hero is h-9/text-base, the compact card is h-8/text-xs) on top,
 * so the family reads identical while each fits its surface.
 */

/**
 * The filled-teal primary "attend" treatment: Turquoise_600 fill + the app's
 * standard teal glow (the same `shadow-glow-teal` NotFound / AdminInvite /
 * CommunityHero primary teal CTAs use — not a new shadow) + the dark-step hover.
 * `border-mb-teal` is a no-op over the fill but keeps parity with the hero's
 * bordered pill base so an outline sibling and this fill size identically.
 * The label is `text-mb-ink`: 8.37:1 on the fill and 5.84:1 on the hover, where
 * white measures 2.08:1 (TECH-746).
 */
export const EVENT_JOIN_CTA_CLASS =
  'bg-mb-teal text-mb-ink border-mb-teal shadow-glow-teal hover:bg-mb-teal-dark';
